import React, { useEffect, useState } from "react";
import { useTranslation } from "react-i18next";
import Box from "@mui/material/Box";
import Tabs from "@mui/material/Tabs";
import Tab from "@mui/material/Tab";
import Grid from "@mui/material/Grid";
import {
  Button,
  FormControl,
  InputAdornment,
  InputLabel,
  MenuItem,
  Select,
  TextField,
} from "@mui/material";
import AddOutlinedIcon from "@mui/icons-material/AddOutlined";
import DataTable from "./DataTable";
import { useDispatch, useSelector } from "react-redux";
import { fetchAllUsers } from "../../redux/actions/usersManagementActionCreators";
import AddModal from "./AddModal";
import { useMediaQuery } from "@mui/material";
import AccordionRole from "./AccordionRoles";
import { Search } from "tabler-icons-react";
import UserDetails from "./UserDetails";
import { Autocomplete } from "@mui/material";
import SingleUserLimitDialog from "./SingleUserLimitDialog";


function TabPanel(props) {
  const { children, value, index, ...other } = props;
  const isMobile = useMediaQuery("(max-width:900px)");
  return (
    <div
      role="tabpanel"
      hidden={value !== index}
      id={`simple-tabpanel-${index}`}
      aria-labelledby={`simple-tab-${index}`}
      {...other}
    >
      {value === index && (
        <Box sx={{ width: "100%", mt: !isMobile ? 7 : 3 }}>{children}</Box>
      )}
    </div>
  );
}

function a11yProps(index) {
  return {
    id: `simple-tab-${index}`,
    "aria-controls": `simple-tabpanel-${index}`,
  };
}

const RoleManagement = () => {
  const profiles = useSelector((state) => state.users.organizations);
  const allUsers = useSelector((state) => state.users.all);
  const totalPages = useSelector((state) => state.users.totalPages);

  const storedUser = localStorage.getItem("user");
  const accountType = JSON.parse(storedUser).account_type;
  const superAdmin = JSON.parse(storedUser).super_admin;
  const role = JSON.parse(storedUser).role;

  const [value, setValue] = useState(0);
  const [open, setOpen] = useState(false);
  const [data, setData] = useState({});
  const [userEmails, setUserEmails] = useState([]);
  const [tabs, setTabs] = useState("all");
  const id_owner = parseInt(localStorage.getItem("orgaId"));
  const [openDetails, setOpenDetails] = useState(false);
  const [selectedUser, setSelectedUser] = useState({});
  const [filter, setFilter] = useState(null);
  const [searchText, setSearchText] = useState("");
  const [page, setPage] = useState(1);
  const [openLimitDialog, setOpenLimitDialog] = useState(false);

  const dispatch = useDispatch();

  const { t } = useTranslation();

  const handleChange = (event, newValue) => {
    setValue(newValue);
    if (newValue === 1) {
      setTabs("confirmed");
    } else if (newValue === 2) {
      setTabs("pending");
    } else {
      setTabs("all");
    }
  };

  const handleCloseDetails = () => {
    setOpenDetails(false);
  };

  const handleSearchText = (text) => {
    setSearchText(text);
    setPage(1);
  };

  const handlePage = (pageNumber) => {
    setPage(pageNumber);
  };

  const handleSelectedUser = (user) => {
    if (user?.role !== "enterprise_admin" && user?.role !== "cytailor_admin") {
      setOpenDetails(true);
      setSelectedUser(user);
    }
  };

  const usersHead = [
    { align: "left", value: t("username"), width: "20%" },
    { align: "left", value: t("email_address"), width: "30%" },
    { align: "left", value: t("role"), width: "20%" },
    { align: "left", value: t("account_status"), width: "20%" },
    { align: "right", value: "", width: "10%" },
  ];

  useEffect(() => {
    dispatch(fetchAllUsers(page, searchText, tabs, filter?.orga_id));
  }, [dispatch, page, searchText, tabs, filter]);

  const handleClose = () => {
    setOpen(false);
  };

  const handleData = (asset) => {
    setData(asset);
  };

  useEffect(() => {
    setUserEmails(allUsers?.map((el) => el?.email));
  }, [allUsers]);

  const isMobile = useMediaQuery("(max-width:900px)");
  return (
    <Box
      sx={{ padding: !isMobile ? "0px 54px" : "0px 15px" }}
      mt={isMobile ? 2 : 6}
    >
      <Grid container spacing={1} padding={0}>
        <Grid item sm={12} xs={12} md={((role === "cytailor_admin") || role==="enterprise_admin") ? 7 : 9}>
          <TextField
            fullWidth
            id="outlined-start-adornment"
            value={searchText}
            onChange={(e) => handleSearchText(e.target.value)}
            placeholder={t("search")}
            InputProps={{
              startAdornment: (
                <InputAdornment position="start">
                  {" "}
                  <Search size={22} strokeWidth={2} color="#8F9BB2" />
                </InputAdornment>
              ),
            }}
          />
        </Grid>
        <Grid item sm={6} xs={12} md={3}>
          <Autocomplete
            value={filter?.orga_name}
            name="enterpriseOrganisation"
            onChange={(e, value) => setFilter(value)}
            id="tags-standard"
            options={profiles}
            getOptionLabel={(option) => option.orga_name}
            fullWidth
            renderInput={(params) => (
              <TextField {...params} label={t("filter_by_orga")} />
            )}
          />
        </Grid>
        {((role === "cytailor_admin") || role==="enterprise_admin") && (
          <Grid item sm={6} xs={12} md={2}>
            <Button
              variant="contained"
              color="button"
              fullWidth
              sx={{ height: "50px" }}
              // onClick={() => {
              //   setOpen(true);
              // }}
              onClick={() => setOpenLimitDialog(true)}
            >
              <AddOutlinedIcon />
              {t("add_user")}
            </Button>
          </Grid>
        )}
      </Grid>

      <Box
        sx={{ borderBottom: 1, borderColor: "divider", mt: isMobile ? 2 : 5 }}
      >
        <Tabs
          value={value}
          onChange={handleChange}
          aria-label="basic tabs example"
          variant="scrollable"
        >
          <Tab label={t("users_roles")} {...a11yProps(0)} />
          <Tab label={t("confirmed_account_tab")} {...a11yProps(1)} />
          <Tab label={t("non_confirmed_account_tab")} {...a11yProps(2)} />
        </Tabs>
      </Box>
      <TabPanel value={value} index={0} sx={{ width: "100%" }}>
        {isMobile ? (
          <AccordionRole
            head={usersHead}
            rows={allUsers
              .filter((el) => el)
              .sort((a, b) => {
                if (
                  a.role === "admin" ||
                  a.role === "enterprise_admin" ||
                  a.role === "cytailor_admin" ||
                  (accountType === "free" && a.role === "enterprise_user")
                )
                  return -1;
                if (
                  b.role === "admin" ||
                  b.role === "enterprise_admin" ||
                  b.role === "cytailor_admin" ||
                  (accountType === "free" && b.role === "enterprise_user")
                )
                  return 1;
              })}
            handleSelectedUser={handleSelectedUser}
            page={page}
            handlePage={handlePage}
            totalPages={totalPages}
            searchText={searchText}
            tabs={tabs}
            filter={filter?.orga_id}
          />
        ) : (
          <DataTable
            head={usersHead}
            rows={allUsers
              .filter((el) => el)
              .sort((a, b) => {
                if (
                  a.role === "admin" ||
                  a.role === "enterprise_admin" ||
                  a.role === "cytailor_admin" ||
                  (accountType === "free" && a.role === "enterprise_user")
                )
                  return -1;
                if (
                  b.role === "admin" ||
                  b.role === "enterprise_admin" ||
                  b.role === "cytailor_admin" ||
                  (accountType === "free" && b.role === "enterprise_user")
                )
                  return 1;
              })}
            handleSelectedUser={handleSelectedUser}
            page={page}
            handlePage={handlePage}
            totalPages={totalPages}
            searchText={searchText}
            tabs={tabs}
            filter={filter?.orga_id}
          />
        )}
      </TabPanel>
      <TabPanel value={value} index={1} sx={{ width: "100%" }}>
        {isMobile ? (
          <AccordionRole
            head={usersHead}
            rows={allUsers
              .filter((el) => el)
              .sort((a, b) => {
                if (
                  a.role === "admin" ||
                  a.role === "enterprise_admin" ||
                  a.role === "cytailor_admin" ||
                  (accountType === "free" && a.role === "enterprise_user")
                )
                  return -1;
                if (
                  b.role === "admin" ||
                  b.role === "enterprise_admin" ||
                  b.role === "cytailor_admin" ||
                  (accountType === "free" && b.role === "enterprise_user")
                )
                  return 1;
              })}
            handleSelectedUser={handleSelectedUser}
            page={page}
            handlePage={handlePage}
            totalPages={totalPages}
            searchText={searchText}
            tabs={tabs}
            filter={filter?.orga_id}
          />
        ) : (
          <DataTable
            head={usersHead}
            rows={allUsers
              .filter((el) => el)
              .sort((a, b) => {
                if (
                  a.role === "admin" ||
                  a.role === "enterprise_admin" ||
                  a.role === "cytailor_admin" ||
                  (accountType === "free" && a.role === "enterprise_user")
                )
                  return -1;
                if (
                  b.role === "admin" ||
                  b.role === "enterprise_admin" ||
                  b.role === "cytailor_admin" ||
                  (accountType === "free" && b.role === "enterprise_user")
                )
                  return 1;
              })}
            handleSelectedUser={handleSelectedUser}
            page={page}
            handlePage={handlePage}
            totalPages={totalPages}
            searchText={searchText}
            tabs={tabs}
            filter={filter?.orga_id}
          />
        )}
      </TabPanel>
      <TabPanel value={value} index={2} sx={{ width: "100%" }}>
        {isMobile ? (
          <AccordionRole
            head={usersHead}
            rows={allUsers
              .filter((el) => el)
              .sort((a, b) => {
                if (
                  a.role === "admin" ||
                  a.role === "enterprise_admin" ||
                  a.role === "cytailor_admin" ||
                  a.role === "cytailor_admin" ||
                  (accountType === "free" && a.role === "enterprise_user")
                )
                  return -1;
                if (
                  b.role === "admin" ||
                  b.role === "enterprise_admin" ||
                  b.role === "cytailor_admin" ||
                  b.role === "cytailor_admin" ||
                  (accountType === "free" && b.role === "enterprise_user")
                )
                  return 1;
              })}
            handleSelectedUser={handleSelectedUser}
            page={page}
            handlePage={handlePage}
            totalPages={totalPages}
            searchText={searchText}
            tabs={tabs}
            filter={filter?.orga_id}
          />
        ) : (
          <DataTable
            head={usersHead}
            rows={allUsers
              .filter((el) => el)
              .sort((a, b) => {
                if (
                  a.role === "admin" ||
                  a.role === "enterprise_admin" ||
                  a.role === "cytailor_admin" ||
                  (accountType === "free" && a.role === "enterprise_user")
                )
                  return -1;
                if (
                  b.role === "admin" ||
                  b.role === "enterprise_admin" ||
                  b.role === "cytailor_admin" ||
                  (accountType === "free" && b.role === "enterprise_user")
                )
                  return 1;
              })}
            handleSelectedUser={handleSelectedUser}
            page={page}
            handlePage={handlePage}
            totalPages={totalPages}
            searchText={searchText}
            tabs={tabs}
            filter={filter?.orga_id}
          />
        )}
      </TabPanel>
      <SingleUserLimitDialog
        open={openLimitDialog}
        handleClose={() => setOpenLimitDialog(false)}
      />
      <AddModal
        open={open}
        handleClose={handleClose}
        userEmails={userEmails}
        users={allUsers}
        profiles={profiles}
        page={page}
        text={searchText}
        tabs={tabs}
        filter={filter?.orga_id}
        superAdmin={superAdmin}
      />
      <UserDetails
        open={openDetails}
        handleClose={handleCloseDetails}
        selectedUser={selectedUser}
      />
    </Box>
  );
};

export default RoleManagement;
